document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('[data-quote-modal]');

  if (!modal) return;

  const closeButton = document.getElementById('QuoteModalClose');
  const productNameInput = document.getElementById('QuoteModalProductName');
  const quoteForm = document.getElementById('QuoteModalForm');
  const triggerSelector = '[data-open-quote-popup]';

  function showModal() {
    modal.style.display = 'flex';
  }

  function closeModal() {
    modal.style.display = 'none';

    const url = new URL(window.location.href);
    url.searchParams.delete('contact_posted');
    if (url.hash == '#QuoteModalForm' || url.hash == '#ContactForm') {
      url.hash = '';
    }
    window.history.replaceState(null, '', url.pathname + url.search + url.hash);
  }

  function prefillProduct(trigger) {
    if (!productNameInput || !trigger) return;

    const productTitle = trigger.getAttribute('data-quote-product-title');

    if (productTitle) {
      productNameInput.value = productTitle;
    }
  }

  function openFromTrigger(trigger) {
    prefillProduct(trigger);
    showModal();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(triggerSelector);

    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      openFromTrigger(trigger);
      return;
    }

    if (closeButton && event.target === closeButton) {
      closeModal();
      return;
    }

    if (event.target === modal) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    const trigger = event.target.closest(triggerSelector);

    if (
      trigger
      && trigger.tagName !== 'BUTTON'
      && (event.key == 'Enter' || event.key == ' ')
    ) {
      event.preventDefault();
      openFromTrigger(trigger);
      return;
    }

    if (event.key == 'Escape' && modal.style.display == 'flex') {
      closeModal();
    }
  });

  window.addEventListener('load', () => {
    const url = new URL(window.location.href);

    if (
      url.searchParams.has('contact_posted')
      && (url.hash == '#QuoteModalForm' || url.hash == '#ContactForm')
    ) {
      showModal();
    }
  });

  if (quoteForm) {
    quoteForm.addEventListener('submit', () => {
      if (window.location.hash != '#QuoteModalForm') {
        window.location.hash = 'QuoteModalForm';
      }
    });
  }
});
